<template>
  <div class="customer-list">
    <refresh-list
      @onLoad="getList"
      :list="list"
      @onRefresh="getList"
      ref="refreshList"
    >
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item
          v-for="(item, index) in list"
          :name="index"
          :key="index"
          :title="item.couponName"
        >
          <div class="content">
            <div class="list">
              <span class="list-left">优惠券开始时间</span>
              <span class="list-right">{{ item.startTime }}</span>
            </div>
            <div class="list">
              <span class="list-left">优惠券结束时间</span>
              <span class="list-right">{{ item.endTime }}</span>
            </div>
            <div class="list">
              <span class="list-left">优惠券面值</span>
              <span class="list-right">{{ item.couponFaceValue }}</span>
            </div>
            <div class="list">
              <span class="list-left">使用门槛</span>
              <span class="list-right">{{ item.useDoorsill }}</span>
            </div>
            <div class="list">
              <span class="list-left">优惠券总数量</span>
              <span class="list-right">{{ item.couponSum }}</span>
            </div>
            <div class="list">
              <span class="list-left">每人最多领取数量</span>
              <span class="list-right"> {{ item.everyoneMaxGetNumber }}</span>
            </div>
            <div class="list">
              <span class="list-left">使用规则</span>
              <span class="list-right"> {{ item.useRule }}</span>
            </div>
            <div class="list">
              <span class="list-left">剩余数量</span>
              <span class="list-right"> {{ item.remainingQuantity }}</span>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </refresh-list>
  </div>
</template>

<script>
import refreshList from "@/components/refresh-list/refresh-list";
export default {
  components: {
    refreshList,
  },
  computed: {
    activityId() {
      return this.$route.query.activityId
    }
  },
  data() {
    return {
      activeName: "1",
      list: [],
    };
  },

  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.$api.coupon.getCouponList(this.activityId)
        .then((res) => {
          if (res.code == 200) {
            this.list = res.data.map((item) => ({
              ...item,
              showPopover: false,
            }));
          } 
        }).finally(() => {
          this.$refs["refreshList"].onFinish(); 
        })
    },
  },
};
</script>
<style lang="stylus" scoped>
.customer-list {
  .van-pull-refresh {
    min-height: 100vh;
    .title {
      display: flex;
      justify-content: space-between;
      color: #333333;
      font-size: 16px;
    }
    .content {
      .list {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 10px 0;
        color: #999999;
        font-size: 14px;
        .list-right {
          position relative
          display: flex;
          justify-content: flex-end;
          align-items: center;
          width: 230px;
          flex-wrap: wrap;
          color: #333333;
        }
      }
    }
  }
}
</style>
